import { keyBy } from "lodash";
import type { IId } from "~/client/resources";

export const toResourceLookup = <T extends IId>(items: ArrayLike<T>) => keyBy(items, (x) => x.Id);

export default toResourceLookup;
